import { IStoryletState } from 'types/storylet';

export default function chooseBranchSuccess(state: IStoryletState, payload: any) {
  const {
    eligibleFriends,
    endStorylet,
    externalSocialAct,
    mapUpdated,
    messages,
    phase,
    rename,
    secondChance,
    socialAct,
    storylet,
    storylets,
  } = payload;
  return {
    ...state,
    eligibleFriends,
    endStorylet,
    storylets,
    phase,
    mapUpdated,
    messages,
    rename,
    socialAct,
    externalSocialAct,
    secondChance,
    addedFriendId: 0,
    isChoosing: false,
    message: null,
    storylet: storylet || state.storylet,
  };
}